import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import Button from 'client/components/lego/button';

import Contact from 'client/components/contact';
import Socials from 'client/components/socials';

import {
    ContactSectionAddress,
    ContactSectionForm,
    PrefooterData
} from 'client/bundles/types';

import './index.css';

const b = cn('prefooter');

interface Props {
    prefooter: PrefooterData;
}

class Prefooter extends Component<Props> {
    static contextType = LangContext;

    renderSectionTitle = (title: string | undefined) => {
        if (!title) {
            return null;
        }

        return (<h3 className={b('company')}>{title}</h3>);
    }

    renderSection = (data: ContactSectionAddress) => {
        if (!data.name && !data.text) {
            return null;
        }

        return (
            <>
                {
                    data.contact &&
                    <div className={b('contacts')}>
                        <Contact contact={data.contact} />
                    </div>
                }

                {
                    data.contacts &&
                    <div className={b('contacts')}>
                        <div className={b('contacts-column')}>
                            <Contact contact={data.contacts.headquaters} />
                            <Contact contact={data.contacts.adv} />
                            <Contact contact={data.contacts.ir} />
                            <Contact contact={data.contacts.pr} />
                            <Contact contact={data.contacts.secretary} />
                            <Contact contact={data.contacts.sustainability} />
                        </div>
                    </div>
                }
            </>
        );
    }

    renderButton = (data: ContactSectionForm, params?: {viewDefault?: boolean}) => {
        if (!data.buttonText || !data.buttonLink) {
            return null;
        }

        return (
            <Button
                className={b('button')}
                theme={params?.viewDefault ? undefined : 'action'}
                view={params?.viewDefault ? 'default' : undefined}
                size="m"
                type="link"
                rel="noopener noreferrer"
                url={data.buttonLink}
                >
                {data.buttonText}
            </Button>
        );
    }

    renderAdditionalInfo = (additionalInfo: string | undefined) => {
        if (!additionalInfo) {
            return null;
        }

        return (
            <div className={b('row')}>
                <div
                    className={b('additional')}
                    dangerouslySetInnerHTML={{ __html: additionalInfo }}
                    />
            </div>
        );
    }

    render() {
        const { prefooter: { moscowContacts, ask, additionalInfo, socials } } = this.props;
        const { lang } = this.context;

        return (
            <section className={b()} id={'prefooter'}>
                <div className={b('content')}>
                    <div className={b('row')}>
                        <div className={b('section-head')}>
                            { this.renderSectionTitle(moscowContacts.name) }
                            <h4 className={b('title')}>{moscowContacts.text}</h4>
                        </div>
                    </div>

                    <div className={b('row')}>
                        <div className={b('column', { left: true })}>
                            {this.renderSection(moscowContacts)}
                        </div>

                        <div className={b('column', { right: true })}>
                            {
                                socials && socials.items?.length > 0 &&
                                    <div className={b('socials')}>
                                        <Socials socials={socials} />
                                    </div>
                            }

                            {
                                ask.buttonText && lang === 'ru' &&
                                <div className={b('contact-link')}>
                                    {this.renderButton(ask, { viewDefault: true })}
                                </div>
                            }
                        </div>
                    </div>

                    {this.renderAdditionalInfo(additionalInfo)}
                </div>
            </section>
        );
    }
}

export default Prefooter;
